import { CEAttributeSpecAttributesBase } from './ce-attribute-spec-attributes-base'


export class CEAttributeSpecAttributes extends CEAttributeSpecAttributesBase {

}